<template>
  <div style="background-color: #edf4fc;padding-bottom: 0.1rem;">
    <div style="overflow: hidden;">
      <div class="celebrity-content">
        <div style="overflow: hidden;border: 1px dashed rgb(223, 221, 221);margin-bottom: 0.1rem;">
          <div>
            <div style="font-size: 0.13rem; margin: 0.1rem 0.1rem 0.05rem; color: #4f2f4f">根据机构名称搜索机构信息：</div>
            <div class="content-input">
              <el-input
                v-model="name"
                placeholder="请输入机构名称"
                class="content-input-el"
                clearable
                @keyup.enter.native="nameTrainFind()"
              >
              </el-input>
              <el-button
                type="primary"
                style="height: 0.34rem; margin-left: 0.2rem"
                @click="nameTrainFind()"
              >
                搜索
              </el-button>
            </div>
          </div>
        </div>
        <div class="celebrity-content-1">
          <div class="content-body-box" v-for="item in dataTrain" :key="item.id">
            <div class="box-img">
              <img :alt="item.file" class="img-center" :src="item.file">
            </div>
            <div class="box-info-1">
              <span>机构名称：{{ item.name }}</span>
            </div>
            <div class="box-info-1">
              市场价：<span style="color: blue;">￥{{ item.price1 }}</span>
              &nbsp;&nbsp;&nbsp;
              优惠价：<span style="color: red;">￥{{ item.price2 }}</span>
            </div>
            <div class="box-info-1">
              <span>库存：{{ item.inventory }}</span>
              &nbsp;&nbsp;&nbsp;
              <span>销量：{{ item.sales }}</span>
            </div>
            <div class="box-info-1">
              <span>机构编号：{{ item.item }}</span>
              &nbsp;&nbsp;&nbsp;
              <span>点数：{{ item.number }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <div class="independence">
        <div class="independence-div">
          <a href="javascript:void(0);" @click="contentFind()">点击查看全部机构</a>
        </div>
        <div class="independence-div">
          <div class="news">推荐机构</div>
          <div v-for="item in dataTrainSuggest" :key="item.id" class="divcolor">
            <a href="javascript:void(0);" class="cell-link" @click="nameTrain(item.name)">
              {{ item.name }}
            </a>
          </div>
        </div>
        <div class="independence-div">
          <div class="news">最近发布机构</div>
          <div v-for="item in dataTrainTime" :key="item.id" class="divcolor">
            <a href="javascript:void(0);" class="cell-link" @click="nameTrain(item.name)">
              {{ item.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectTrainAPI, getTrainNameAPI, selectTrainTimeAPI, selectTrainSuggestAPI } from '@/api/trainAPI'

export default {
  name: 'Train',
  data() {
    return {
      name: '',
      currentPage: 1,
      pageSize: 6,
      total: 1,
      dataTrain: [],
      dataTrainTime: [],
      dataTrainSuggest: [],
      idButton: 0
    }
  },
  created() {
    this.contentFind()
    this.timeFind()
    this.suggestFind()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async contentFind() {
      const { data: res } = await selectTrainAPI(this.currentPage, this.pageSize)
      this.dataTrain = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
    },
    async timeFind() {
      const { data: res } = await selectTrainTimeAPI(1, 6)
      this.dataTrainTime = res.data[2]
    },
    async suggestFind() {
      const { data: res } = await selectTrainSuggestAPI(1, 6)
      this.dataTrainSuggest = res.data[2]
    },
    async nameTrainFind() {
      this.currentPage = 1
      const { data: res } = await getTrainNameAPI(this.name, this.currentPage, this.pageSize)
      this.dataTrain = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
    },
    async nameTrain(name) {
      this.currentPage = 1
      const { data: res } = await getTrainNameAPI(name, this.currentPage, this.pageSize)
      this.dataTrain = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      document.documentElement.scrollTop = 380
      if (this.idButton === 1) {
        const { data: res } = await getTrainNameAPI(this.name, this.currentPage, this.pageSize)
        this.dataTrain = res.data[2]
        this.total = res.data[0]
      }
      if (this.idButton === 3) {
        const { data: res } = await selectTrainAPI(this.currentPage, this.pageSize)
        this.dataTrain = res.data[2]
        this.total = res.data[0]
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a:hover {
  color: red;
}
a p div span {
  font-size: 0.13rem;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.celebrity-content {
  width: 70%;
  margin-left: 1%;
  margin-top: 0.1rem;
  float: left;
}
.celebrity-content-1 {
  overflow: hidden;
  border-left: 1px dashed rgb(223, 221, 221);
  border-right: 1px dashed rgb(223, 221, 221);
  border-top: 1px dashed rgb(223, 221, 221);
  padding: 0.1rem;
  padding-bottom: 0;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 2rem;
  }
}
.content-body-box:nth-child(odd) {
  float: left;
  height: 2.2rem;
  width: 48.5%;
  margin-bottom: 0.2rem;
  margin-right: 0!important;
  background-color: rgb(247, 247, 247);
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
}
.content-body-box:nth-child(even) {
  float: right;
  height: 2.2rem;
  width: 48.5%;
  margin-bottom: 0.2rem;
  background-color: rgb(247, 247, 247);;
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
}
.box-img {
  max-height: 0.9rem;
  margin: 0.1rem;
}
.img-center {
  max-height: 0.9rem;
  max-width: 3rem;
  display: block;
}
.box-info-1 {
  margin-top: 0.1rem;
  padding-left: 0.1rem;
  font-size: 0.13rem;
}
.pagination {
  padding-bottom: 0.1rem;
  border-bottom: 1px dashed rgb(223, 221, 221);
  border-left: 1px dashed rgb(223, 221, 221);
  border-right: 1px dashed rgb(223, 221, 221);
}
.independence {
  float: right;
  width: 28%;
}
.independence-div {
  border: 1px dashed rgb(223, 221, 221);
  margin-top: 0.1rem;
  margin-right: 0.1rem;
  padding: 0.1rem;
  font-size: 0.13rem;
}
.independence-div a:hover {
  color: red;
}
.independence-div div a:hover {
  color: blue;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.05rem;
  font-size: 0.17rem;
  font-weight: 700;
  text-align: center;
}
.cell-link {
  display: inline-block;
  font-size: 0.13rem;
  width: 2.4rem;
  padding: 0.06rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.divcolor:hover {
  background-color: rgb(163, 252, 163);
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
